import { render } from "./StatCard.vue?vue&type=template&id=5d9a250e&ts=true"
import script from "./StatCard.vue?vue&type=script&lang=ts"
export * from "./StatCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__